export default "__VITE_ASSET__DZECV87r__"